import React from 'react';
import LocalizedLink from '../ui/LocalizedLink';
import { ChevronRight } from 'react-feather';

interface BreadcrumbItem {
  name: string;
  path: string;
}

interface BreadcrumbsProps {
  crumbs: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ crumbs }) => {
  if (!crumbs || crumbs.length === 0) {
    return null;
  }

  return (
    <div className="bg-brand-dark/50 border-b border-white/10">
      <nav className="mx-auto max-w-7xl px-6 py-2" aria-label="Breadcrumb">
        <ol className="flex items-center space-x-2 text-sm">
          {crumbs.map((crumb, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <ChevronRight
                  className="h-4 w-4 text-white/50 mx-2 flex-shrink-0"
                  aria-hidden="true"
                />
              )}
              <LocalizedLink
                to={crumb.path}
                className={`
                  ${index === crumbs.length - 1 ? 'text-white/90 font-semibold' : 'text-white/70 hover:text-white'}
                  transition-colors
                `}
                aria-current={index === crumbs.length - 1 ? 'page' : undefined}
              >
                {crumb.name}
              </LocalizedLink>
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumbs;